import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import moment from 'moment'
import _ from 'moment-timezone'

import DelayCertificateOverview from './DelayCertificateOverview'
import DelayCertificateFooterRemark from './DelayCertificateFooterRemark'
import DelayCertificateHelper from './DelayCertificateHelper'

import ScrollToTop from '../shared/ScrollToTop'

const DelayCertificateList = ({ delayCertificates }) => {

  const findDelayCertificate = (date, delayTimeZone) => {
    return delayCertificates.find(c => (
      c.delay_date === date.format('Y-MM-DD') &&
      c.delay_time_zone === delayTimeZone
    ))
  }

  const renderDelayTimeZone = (date, delayTimeZone) => {
    const c = findDelayCertificate(date, delayTimeZone)
    if (c) {
      return (
        <li><Link to={`/delay_certificates/${c.id}`} className="d-Delay-tableLink">{DelayCertificateHelper.delayTimeZoneHuman(delayTimeZone)}</Link></li>
      )
    } else {
      return (
        <li>{DelayCertificateHelper.delayTimeZoneHuman(delayTimeZone)}</li>
      )
    }
  }

  const renderDelayTime = (date, delayTimeZone) => {
    const c = findDelayCertificate(date, delayTimeZone)
    if (c) {
      return (
        <li><Link to={`/delay_certificates/${c.id}`} className="d-Delay-tableLink">{DelayCertificateHelper.delayTimeHuman(c.delay_time)}</Link></li>
      )
    } else {
      return (
        <li>-</li>
      )
    }
  }

  const renderDelayCertificatesList = () => {
    return [...Array(8)].map((_, i) => {
      let date = moment().subtract(3, 'hours').subtract(i, 'days')
      return(
        <tbody key={date}>
          <tr className="d-Delay-tableBodyRow">
            <td className="d-Delay-tableBodyCell -type-date">{DelayCertificateHelper.formattedDate(date)}</td>
            <td className="d-Delay-tableBodyCell -type-section">
              <ul>
                {renderDelayTimeZone(date, 1)}
                {renderDelayTimeZone(date, 2)}
                {renderDelayTimeZone(date, 3)}
              </ul>
            </td>
            <td className="d-Delay-tableBodyCell -type-delaytime">
              <ul>
                {renderDelayTime(date, 1)}
                {renderDelayTime(date, 2)}
                {renderDelayTime(date, 3)}
              </ul>
            </td>
          </tr>
        </tbody>
      )
    })
  }

  const timeNow = moment().tz('Asia/Tokyo').format("YYYY年M月D日 H時mm分")

  return(
    <div className="d-Delay">
      <ScrollToTop />
      <h1 className="d-Delay-listTitle">遅延証明書</h1>

      <h2 className="d-Delay-tableTitle">本日より前７日間の遅延証明書</h2>
      <p className="d-Delay-tableText">{timeNow}現在の情報です。</p>

      <table className="d-Delay-table">
        <thead>
          <tr className="d-Delay-tableHeaderRow">
            <th className="d-Delay-tableHeaderCell -type-date">日付</th>
            <th className="d-Delay-tableHeaderCell -type-section">時間帯</th>
            <th className="d-Delay-tableHeaderCell -type-delaytime">遅延時間</th>
          </tr>
        </thead>
        {renderDelayCertificatesList()}
      </table>
      <DelayCertificateOverview />
      <DelayCertificateFooterRemark />
    </div>
  )
}

DelayCertificateList.propTypes = {
  delayCertificates: PropTypes.array.isRequired,
}

export default DelayCertificateList
